<style lang="less">
.analysis {
  background: #f3f3f3;
}
</style>
<template>
    <div class="analysis">
        <router-view/>
    </div>
</template>

<script>
export default {
  name: 'Analysis'
}
</script>
